import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PURCHASES_ITEM: {},
  PURCHASES_LIST: [],
  PURCHASES_TABLE_DATA: [],
  PURCHASES_TABLE_PRODUCTS_DATA: [],
  PURCHASES_ARRAY_DATA: [],
  PURCHASES_TOTAL_ROWS: 0
}

export const getters = {
  GET_PURCHASES_ITEM: (state) => {
    return state.PURCHASES_ITEM;
  },
  GET_PURCHASES_LIST: (state) => {
    return state.PURCHASES_LIST;
  },
  GET_PURCHASES_TABLE_DATA: (state) => {
    return state.PURCHASES_TABLE_DATA;
  },
  GET_PURCHASES_TABLE_PRODUCTS_DATA: (state) => {
    return state.PURCHASES_TABLE_PRODUCTS_DATA;
  },
  GET_PURCHASES_ARRAY_DATA: (state) => {
    return state.PURCHASES_ARRAY_DATA;
  },
  GET_PURCHASES_TOTAL_ROWS: (state) => {
    return state.PURCHASES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_PURCHASES_ITEM(state, item) {
    state.PURCHASES_ITEM = item;
  },

  UPDATE_PURCHASES_TABLE_PRODUCTS_DATA(state, list) {

    list = list.data;
    
    state.PURCHASES_TABLE_PRODUCTS_DATA = [];

    list.forEach(el => {
      state.PURCHASES_TABLE_PRODUCTS_DATA.push({
        'id' : el.id,
        'uuid' : el.uuid,
        'product_name': el.product_name,
        'product_uuid': el.product_uuid,
        'product_id': el.product_id,
        'qnt': el.qnt,
        'cost': el.cost,
        'sum': el.sum,
        'unit_name': el.unit_name,
        'unit_code': el.unit_code,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
      });
    });
  },

  UPDATE_PURCHASES_LIST(state, list) {

    state.PURCHASES_LIST = list.data;

    state.PURCHASES_TOTAL_ROWS = list.total;
    list = list.data;

    state.PURCHASES_TABLE_DATA = [];
    state.PURCHASES_ARRAY_DATA = [];

    list.forEach(el => {

      let status = {
        'draft'  : 'Черновик',
        'closed' : 'Закрыт',
        'check'  : 'Проверить'
      }

      state.PURCHASES_TABLE_DATA.push({
        'uuid'   : el.uuid,
        'id'     : el.id,
        'number' : el.number,
        'document_date' : el.document_date,
        'sum'    : el.sum,
        'counterparty_name' : el.counterparty_name,
        'company_name'      : el.company_name,
        'warehouse_name'    : el.warehouse_name,
        'status'     : status[el.status] ? status[el.status] : '',
        'comments'   : el.comments,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.PURCHASES_ARRAY_DATA.push({
        id     : el.id,
        uuid   : el.uuid,
        number : el.id,
        sum    : el.id,
      });
    });
  },
}

export const actions = {

  async FETCH_PURCHASES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/purchases/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PURCHASES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_PURCHASES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/purchases';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PURCHASES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_PURCHASES_LIST_PRODUCTS({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/purchases/' + payload.uuid + '/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PURCHASES_TABLE_PRODUCTS_DATA', response.data);
      return response.data;
    }
  },

  async FETCH_PURCHASES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/purchases';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PURCHASES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/purchases/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PURCHASES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/purchases/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}